import React from "react";
import {
  Box,
  IconButton,
  MenuItem,
  Select,
  Stack,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from "@mui/material";

// Icons
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

// Spinner
import Spinner from "../spinner/Spinner";

const CustomDataTable2 = ({
  sx,
  columns,
  isLoading = false,
  rowsContent,
  rowsPerPageOptions = [10, 20, 50],
  rowsPerPage = 10,
  onRowsPerPageChange,
  handleBackButtonClick,
  handleNextButtonClick,
}: {
  sx?: SxProps<Theme>;
  columns: React.ReactNode[];
  isLoading?: boolean;
  rowsContent: React.ReactNode[] | React.ReactNode;
  rowsPerPageOptions?: number[];
  rowsPerPage?: number;
  onRowsPerPageChange?: (event: number) => void;
  handleBackButtonClick?: () => void;
  handleNextButtonClick?: () => void;
}) => {
  // Custom Pagination Actions
  const TablePaginationActions = () => {
    return (
      <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
        <IconButton onClick={handleBackButtonClick} aria-label="previous page">
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton onClick={handleNextButtonClick} aria-label="next page">
          <KeyboardArrowRight />
        </IconButton>
      </Box>
    );
  };

  return (
    <TableContainer sx={sx}>
      <Table>
        <TableHead
          className="custom_table_thead"
          sx={{
            position: "sticky",
            top: 0,
            backgroundColor: "#F2F3F5 !important",
            zIndex: 10,
            borderTop: "1px solid #DCDCDC",
            borderBottom: "1px solid #DCDCDC",
          }}
        >
          <TableRow>
            {columns?.map((column, index) => (
              <TableCell key={index} className="custom_table_thead_cell">
                {column}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={columns?.length} sx={{ textAlign: "center" }}>
                <Spinner />
              </TableCell>
            </TableRow>
          ) : rowsContent &&
            Array.isArray(rowsContent) &&
            rowsContent.length > 0 ? (
            rowsContent
          ) : (
            <TableRow>
              <TableCell colSpan={columns?.length} sx={{ textAlign: "center" }}>
                <Typography variant="body1" fontSize={"15px"} fontWeight={600}>
                  No Data Found
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>

        <TableFooter>
          <TableRow>
            <TableCell
              colSpan={columns.length}
              sx={{ padding: 0, borderBottom: 0 }}
            >
              <Box
                sx={{
                  padding: "6px 10px",
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={2}
                >
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Typography
                      variant="body1"
                      fontSize={"12px"}
                      fontWeight={700}
                    >
                      Rows per page
                    </Typography>
                    <Select
                      variant="outlined"
                      sx={{
                        border: "none",
                        minWidth: 64,
                        fontSize: "12px",
                        fontWeight: 600,
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                      size="small"
                      value={rowsPerPage}
                      onChange={(e) =>
                        onRowsPerPageChange?.(Number(e.target.value))
                      }
                    >
                      {rowsPerPageOptions.map((val) => (
                        <MenuItem value={val}>{val}</MenuItem>
                      ))}
                    </Select>
                  </Stack>

                  <TablePaginationActions />
                </Stack>
              </Box>
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default CustomDataTable2;
